import request from '@/utils/request'
import { AxiosResult } from '@/typings/common'
// import { } from '@/typings/api/index'

/**
 * ************************************** 首页 **************************************
 */
// 线索投放情况
export function zbuCluePutCondition(params?: {countDate:string}) {
  return request.get<AxiosResult>('/zbu/api/homePage/getCluePutCondition', { params })
}
// 数据汇总
export function zbuGetDataSummary() {
  return request.get<AxiosResult>('/zbu/api/homePage/getSummary')
}
// 无效原因分析
export function zbuGetInvalidAnalysis(params?: {countDate:string}) {
  return request.get<AxiosResult>('/zbu/api/homePage/getInvalidAnalysis', { params })
}
// 获取市场线索的上次对接人
export function getLastConductor() {
  return request.post<AxiosResult>('/zbu/api/clue/last/conductor')
}
